import { Box, Container, Heading, Text, VStack } from "@chakra-ui/react"
import { Helmet } from "react-helmet"

export default function TermsConditions() {
  return (
    <>
      <Helmet>
        <title>Terms & Conditions - SpearBI</title>
        <meta name="description" content="Terms and conditions for using the SpearBI Reporting System" />
      </Helmet>
      <Container maxW="4xl" py={8}>
        <VStack spacing={6} align="stretch">
          <Heading as="h1" size="xl">
            Terms & Conditions
          </Heading>
          <Text color="gray.500">Effective Date: May 22, 2025</Text>

          <Box>
            <Heading as="h2" size="md" mb={2}>
              Acceptance of Terms
            </Heading>
            <Text>
              By accessing or using the SpearBI Reporting System ("Service"), you agree to be bound by these Terms &
              Conditions ("Terms"). If you do not agree, you must not use the Service.
            </Text>
          </Box>

          <Box>
            <Heading as="h2" size="md" mb={2}>
              Definitions
            </Heading>
            <Text>
              <strong>User:</strong> any individual or entity accessing the Service.
            </Text>
            <Text>
              <strong>Account:</strong> the credentials you use to access the Service.
            </Text>
            <Text>
              <strong>Data:</strong> any information you upload, enter or otherwise transmit to the Service.
            </Text>
          </Box>

          <Box>
            <Heading as="h2" size="md" mb={2}>
              License
            </Heading>
            <Text>
              We grant you a limited, non-exclusive, non-transferable, revocable license to use the Service for your
              internal business purposes in accordance with these Terms.
            </Text>
          </Box>

          <Box>
            <Heading as="h2" size="md" mb={2}>
              User Obligations
            </Heading>
            <VStack spacing={2} align="stretch" pl={4}>
              <Text>• You must provide accurate registration information and keep it up to date.</Text>
              <Text>
                • You are responsible for safeguarding your Account credentials and for any activity under your Account.
              </Text>
              <Text>• You must comply with all applicable laws and regulations when using the Service.</Text>
            </VStack>
          </Box>

          <Box>
            <Heading as="h2" size="md" mb={2}>
              Prohibited Conduct
            </Heading>
            <Text>You must not:</Text>
            <VStack spacing={2} align="stretch" pl={4}>
              <Text>• Reverse engineer, decompile or attempt to extract source code.</Text>
              <Text>• Use the Service to transmit malicious code or infringing content.</Text>
              <Text>• Circumvent any access controls or attempt unauthorized access to other users' data.</Text>
            </VStack>
          </Box>

          <Box>
            <Heading as="h2" size="md" mb={2}>
              Intellectual Property
            </Heading>
            <Text>
              All rights, title and interest in the Service (including all software, visual interfaces, and Content) are
              owned by SpearBI (or its licensors). You retain ownership of Data you upload; we claim no rights over it
              beyond what's needed to provide the Service.
            </Text>
          </Box>

          <Box>
            <Heading as="h2" size="md" mb={2}>
              Data Backups & Retention
            </Heading>
            <Text>
              We perform regular backups but highly recommend you maintain your own copies of all Data. We retain
              inactive Accounts and Data in accordance with our Privacy Policy.
            </Text>
          </Box>

          <Box>
            <Heading as="h2" size="md" mb={2}>
              Warranty Disclaimer
            </Heading>
            <Text>
              The Service is provided "as is" and "as available," without warranty of any kind, whether express or
              implied, including any implied warranties of merchantability or fitness for a particular purpose.
            </Text>
          </Box>

          <Box>
            <Heading as="h2" size="md" mb={2}>
              Limitation of Liability
            </Heading>
            <Text>
              To the maximum extent permitted by law, SpearBI will not be liable for any indirect, incidental, special
              or consequential damages, or loss of profits, data or goodwill, arising out of or relating to these Terms
              or the Service, even if advised of the possibility of such damages.
            </Text>
          </Box>

          <Box>
            <Heading as="h2" size="md" mb={2}>
              Termination
            </Heading>
            <Text>
              We may suspend or terminate your access immediately if you breach these Terms. Upon termination, your
              right to use the Service ends and we may delete or anonymize your Data in accordance with our data
              retention policies.
            </Text>
          </Box>

          <Box>
            <Heading as="h2" size="md" mb={2}>
              Changes to Terms
            </Heading>
            <Text>
              We may update these Terms from time to time. If material changes are made, we'll notify you at least 14
              days before they take effect. Continued use after the effective date constitutes acceptance of the new
              Terms.
            </Text>
          </Box>

          <Box>
            <Heading as="h2" size="md" mb={2}>
              Governing Law & Dispute Resolution
            </Heading>
            <Text>
              These Terms are governed by the laws of the Republic of South Africa. Any disputes will be subject to the
              exclusive jurisdiction of the courts of Johannesburg.
            </Text>
          </Box>

          <Box>
            <Heading as="h2" size="md" mb={2}>
              Contact
            </Heading>
            <Text>For questions about these Terms, please email support@spearbi.org.</Text>
          </Box>
        </VStack>
      </Container>
    </>
  )
}
